import React from "react";
import { Dialog, Tooltip } from "@mui/material";

import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import IconButtonWrapper from "views/pages/manage/common/form-fields-mui/IconButtonWrapper";
import { LastUpdatedDetails } from "views/pages/manage/employeeManagement/userProfile/helper";
import { capitalize } from "views/pages/manage/common/utils/methods/commonMethods/utilityMethod";
import AChip from "views/pages/manage/common/chip/AChip";
import ViewEmployeeName from "views/pages/manage/viewEmployeeName";

const ViewRowDetails = ({ onClose, isOpen, rowData }) => {
  return (
    <Dialog
      aria-label="Course Material Record Details"
      open={isOpen}
      PaperProps={{
        sx: {
          minHeight: "450px",
          minWidth: "370px",
          maxWidth: "400px",
          borderRadius: "12px",
          padding: "20px",
        },
      }}
      onClose={onClose}
    >
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h2 className="mb-0 text-bold">Record Details</h2>

        <IconButtonWrapper
          aria-label="Close the dialog"
          //   tabIndex="0"
          onClick={onClose}
        >
          <CrossIcon />
        </IconButtonWrapper>
      </div>

      <section>
        <p className="mb-2">
          <span className="text-bold">Career: </span>
          {rowData.academicCareer}
        </p>
        <p className="mb-2">
          <span className="text-bold">Language: </span>
          {rowData.language}
        </p>
        <p className="mb-2">
          <span className="text-bold">Class: </span>
          {rowData.classes}
        </p>
        <p className="mb-2">
          <span className="text-bold">Attribute: </span>
          {rowData.attribute}
        </p>

        <div className="mb-2 d-flex flex-wrap">
          <span className="text-bold">Course IDs: &nbsp;</span>

          {/* toltips tags */}
          <div className="d-flex flex-wrap">
            {rowData.courseIds.map(({ label, value }) => (
              <Tooltip title={label} key={value}>
                <span className="ellipsis-text-container">{value},&nbsp;</span>
              </Tooltip>
            ))}
          </div>
        </div>

        <p className="mb-2">
          <span className="text-bold">Year: </span>
          {rowData.year}
        </p>

        <div>
          <p className="text-bold mb-0">Package Code & Material ID:</p>
          {rowData.materialInfo.map((obj, index) => (
            <div key={index} className="d-flex">
              <h4 className="d-flex text-bold">{obj.packageCodeId}: &nbsp;</h4>

              {/* toltips tags */}
              <div className="d-flex flex-wrap">
                {obj.materialIds.map(({ label, value }) => (
                  <Tooltip title={label} key={value}>
                    <h4 className="ellipsis-text-container mb-0">
                      {value},&nbsp;
                    </h4>
                  </Tooltip>
                ))}
              </div>
            </div>
          ))}
        </div>

        <p>
          <span className="text-bold">Last Updated: </span>
          {LastUpdatedDetails(rowData.updatedOn, rowData.updatedBy)}{" "}
          <ViewEmployeeName empId={rowData.updatedBy} />
        </p>

        <div className="d-flex">
          <span className="text-bold mr-2">Status: </span>

          <AChip
            label={capitalize(rowData?.status || "Active")}
            success={rowData?.status?.toUpperCase() === "ACTIVE"}
          />
        </div>
      </section>
    </Dialog>
  );
};

export default ViewRowDetails;
